export default __webpack_public_path__ + "static/media/glasses.b5be6357.glb";